import { FILTERS } from '@graphql/articles'
import * as I from '@graphql/__generated__/Filters'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'urql'
import { FilterAction, FilterState, Filters as IFilters } from '../reducer'
import FilterBar from './FilterBar'
import MobileFilters from './MobileFilters'
import { ArticlesVariables } from '@graphql/__generated__/Articles'

type Props = FilterState & {
  type: string
  totalProducts?: number
  areProductsLoading?: boolean
  dispatch: React.Dispatch<FilterAction>
  variables: ArticlesVariables
  fixedFilters: IFilters
}

const Filters = React.forwardRef<HTMLDivElement, Props>(
  (
    { type, totalProducts, areProductsLoading, dispatch, variables, fixedFilters, ...state },
    ref
  ) => {
    const [attributes, setAttributes] = useState([])
    const [brandOptions, setBrandOptions] = useState([])
    const [collectionOptions, setCollectionOptions] = useState([])
    const [result] = useQuery<I.Filters, I.FiltersVariables>({
      query: FILTERS,
      variables: {
        filters: variables.filters
      }
    })
    // We put the results in state here to prevent showing the loading state between changes
    // The loading state is fine on initial load, but when saving a filter set, it can be annoying.
    useEffect(() => {
      if (result.data) {
        setAttributes(
          result.data.filters.articleAttributeFilters.filter(
            item => typeof fixedFilters[item.attributeID] === 'undefined'
          )
        )
        // - Collectie filter alleen op merk pagina
        // - Merk filter overal behalve op de merk pagina
        if (type === 'brand_page') {
          setCollectionOptions(result.data.filters.brandCollectionFilters)
        }
        if (type !== 'brand_page') {
          setBrandOptions(result.data.filters.brandFilters)
        }
      }
    }, [result.data, fixedFilters, type])
    return (
      <>
        <div ref={ref}>
          <FilterBar
            isLoading={result.fetching}
            error={result.error}
            areProductsLoading={areProductsLoading}
            attributes={attributes}
            brandOptions={brandOptions}
            collectionOptions={collectionOptions}
            dispatch={dispatch}
            totalProducts={totalProducts}
            {...state}
          />
        </div>
        {result.data && (
          <MobileFilters
            dispatch={dispatch}
            fixedFilters={fixedFilters}
            brandOptions={brandOptions}
            collectionOptions={collectionOptions}
            attributes={attributes}
            {...state}
          />
        )}
      </>
    )
  }
)

export default Filters
